import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class MaterialStockService {
    static getMaterialStock(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`material-stock?filter=${qs}`, pageNumber));
    }
    static fetchMaterialStock(oid) {
        return lastValueFrom(BaseService.get(`material-stock/${oid}`));
    }
    static saveMaterialStock(dto) {
        return lastValueFrom(BaseService.save(`material-stock`, dto));
    }
    static deleteMaterialStock(oid) {
        return lastValueFrom(BaseService.delete(`material-stock/${oid}`));
    }
    static searchMaterialStockCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`material-stock-search-dropdown/${selfId}?search=${qs}`));
    }
}
